<template>
  <section class="accommodationMobileLinks container">
    <client-only>
      <Button v-for="item in aggregationPagesLinks" type="nuxt-link" :to="item.sef || ''" secondary>
        <template #default>{{ $t(`${ item.isHotel ? 'allResorts' : 'allCampsites'}`) }}</template>
        <template #append><Icon name="arrow-right" /></template>
      </Button>
    </client-only>
  </section>
</template>

<script setup>
  const { aggregationPagesLinks } = useSetup();
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_accommodationMobileLinks.scss');
</style>